var DynamicInput = require('./dynamicInput'),
    fvChannel = require('glRadio').channel('FV'),
    moment = require('moment');


// isValid currently N/A ....

module.exports = DynamicInput.extend({

    idAttribute: 'key',

    getNewGeneratedValue: function(  ) {

        var type = this.get('keyNoSymbol');

        var fvSettings = fvChannel.request('settings');

        if ( type === 'date' ) {
            return moment().format( fvSettings.DATE_FMT_STR);
        }

        /**
         * We aren't storing UTC -- if we did, would need to refactor this and the XML -- these aren't just key-values if anything,
         * and absolutely necessary, could store in XML attribute values.
         */
        if ( type === 'time' ) {
            return moment.getCurrentTimestampWithTimezoneAbbreviation( 'h:mm A' );
        }

    }



});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/notes/models/page/noteTypes/drawable/svg/textStamp/variableInputs/tokenInput.js
 ** module id = 342
 ** module chunks = 0
 **/